var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes },
    [
      _c("div", { staticClass: "bin-tree-org-node-label" }, [
        _vm.data.render
          ? _c(
              "div",
              {
                class: _vm.labelClasses,
                style: _vm.labelStyles,
                on: { click: _vm.handleClick }
              },
              [
                _c("render", {
                  attrs: {
                    render: _vm.data.render,
                    data: _vm.data,
                    node: _vm.node
                  }
                })
              ],
              1
            )
          : _vm.isParentRender
          ? _c(
              "div",
              {
                class: _vm.labelClasses,
                style: _vm.labelStyles,
                on: { click: _vm.handleClick }
              },
              [
                _c("render", {
                  attrs: {
                    render: _vm.parentRender,
                    data: _vm.data,
                    node: _vm.node
                  }
                })
              ],
              1
            )
          : _c(
              "div",
              {
                class: _vm.labelClasses,
                style: _vm.labelStyles,
                on: { click: _vm.handleClick }
              },
              [_vm._v(_vm._s(_vm.data.label))]
            ),
        _vm._v(" "),
        _vm.collapsable && !_vm.isLeaf
          ? _c("span", {
              staticClass: "bin-tree-org-node-btn",
              class: { expand: _vm.data.expand },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.handleExpand($event)
                }
              }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.data[_vm.childrenKey] && _vm.data[_vm.childrenKey].length
        ? [
            !_vm.collapsable || _vm.data.expand
              ? _c(
                  "div",
                  { staticClass: "bin-tree-org-node-children" },
                  _vm._l(_vm.data[_vm.childrenKey], function(item, i) {
                    return _c("tree-node", {
                      key: i,
                      attrs: {
                        data: item,
                        "children-key": _vm.childrenKey,
                        horizontal: _vm.horizontal,
                        "label-style": _vm.labelStyle,
                        collapsable: _vm.collapsable,
                        "label-class-name": _vm.labelClassName
                      }
                    })
                  }),
                  1
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }